import React from "react";
import BasicModal from "../../../../Components/Modals/BasicModal";
import Btn from "../../../../Components/Buttons/Btn";
import { RiDeleteBin5Line } from "react-icons/ri";

const CancelModal = ({ showCancelModal, setShowCancelModal, handleCancel }) => {
  if (showCancelModal) {
    return (
      <BasicModal
        showModal={showCancelModal}
        setShowModal={setShowCancelModal}
        header="Cancel Shipment Order"
      >
        <div className="m-auto p-5">
          <h2 className="text-center text-red text-xl font-bold  mb-6">
            Are you sure you want to cancel this shipment ?
          </h2>
          <div className="flex justify-between items-center">
            <Btn
              outline={true}
              btn="border"
              onClick={() => setShowCancelModal(false)}
            >
              <p className="">Cancel</p>
            </Btn>
            <Btn outline={true} btn="border" onClick={handleCancel}>
              <div className="flex justify-between items-center gap-x-2">
                <RiDeleteBin5Line className="text-red" />
                <p className="">Confirm</p>
              </div>
            </Btn>
          </div>
        </div>
      </BasicModal>
    );
  }
};

export default CancelModal;
